import { useEffect, useState } from "react";

export default function TypingIndicator() {
  const [dots, setDots] = useState(1);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDots((prevDots) => (prevDots < 3 ? prevDots + 1 : 1));
    }, 500);
    return () => clearInterval(intervalId);
  }, []);

  const dotsString = ".".repeat(dots);

  return <span>{dotsString}</span>;
}
